<!-------------------------------------
|   Author: Kartik Mukati          |
|   Date: 24-04-2023                   |
--------------------------------------->
<circle-progress
  [percent]="value"
  [maxPercent]="100"
  [radius]="24"
  [space]="-2"
  [outerStrokeWidth]="3"
  outerStrokeColor="#307FE2"
  innerStrokeColor="#e7e8ea"
  [innerStrokeWidth]="2"
  [title]="[spinnerTitle]"
  titleFontSize="18"
  titleFontWeight="600"
  [showSubtitle]="false"
  [showUnits]="false"
  [startFromZero]="false"
  [animateTitle]="true"
  [animation]="true"
  [clockwise]="true"
></circle-progress>